<template>
	<div class="personal-info">
		<el-form label-width="120px" label-position="left">
			<el-form-item :label="this.$t('personal.avatar')">
				<el-form-item>
					<img style="width: 100px; height: 100px" class="avatar" :src="avatarUrl($store.state.user.avatar)" @click="changeAvatar()" />
				</el-form-item>
			</el-form-item>
			<el-form-item :label="this.$t('personal.nickName')">
				<el-input v-model="$store.state.user.nickName" disabled />
			</el-form-item>
		</el-form>
		<avatar ref="avatarDialog" />
	</div>
</template>

<script>
import avatar from "./components/avatar";

import { ossBaseUrl } from "@/config/env";

export default {
	name: "personal",

	components: {
		avatar,
	},

	methods: {
		changeAvatar() {
			this.$refs.avatarDialog.showDailog();
		},
		avatarUrl(id) {
			return `${ossBaseUrl}/avatars/${id}?x-oss-process=image/resize,w_100`;
		},
	},
};
</script>

<style scoped lang="less">
.personal-info {
	width: 660px;
	padding: 30px 0 0 30px;
	.avatar {
		border-radius: 50%;
		cursor: pointer;
	}
}
</style>
